export const isEmailAddress = (email: string) => !!email.match(/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/g)

export const isUuid = (uuid?: string) =>
  uuid && !!uuid.match(/^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/g)

export const isValidPassword = (pw?: string) =>
  pw && !!pw.match(/^(?=.{8,}$)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]).*$/g)

export const lowerFirst = (string: string) => (string ? string.charAt(0).toLowerCase() + string.slice(1) : '')

export const upperFirst = (str: string) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`

export const toPascalCase = (str: string) => str.replace(/(\w)(\w*)/g, (_, g1, g2) => upperFirst(g1) + g2.toLowerCase())

export const abbreviateNumber = (value: number) =>
  Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value)
